import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Vendor } from '../models/Vendor';
import { environment } from '../../environments/environment';
import { DynamicFormUtilityServices } from './dynamic-form-utility.service';
import { status } from '../models/LoginView';

@Injectable({
  providedIn: 'root',
})
export class VendorInformationChangeRequestService {
  private readonly urlPath = 'vendor-information-change-request';

  constructor(
    private httpClient: HttpClient,
    private dynamicFormUtilityServices: DynamicFormUtilityServices,
  ) {}

  getForm(id: string): Observable<Vendor> {
    const headers = {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
    };
    return this.httpClient
      .get<Vendor>(`${environment.apiUrl}${this.urlPath}/${id}`, { headers })
      .pipe();
  }

  getFormStatus(request: any, prefix: string): Observable<status> {
    return this.httpClient
      .post<status>(
        `${environment.apiUrl}${this.urlPath}/change-request-status`,
        this.Request(request, prefix),
      )
      .pipe();
  }

  createForm(request: any, prefix: string): Observable<Vendor> {
    return this.httpClient
      .post<Vendor>(
        `${environment.apiUrl}${this.urlPath}`,
        this.setupRequest(request, prefix),
      )
      .pipe();
  }
  private setupRequest(request: any, prefix: string) {
    const formData: FormData = new FormData();
    formData.append('vendor W9', request.vendorW9File);
    formData.append('voided Check', request.voidedCheckFile);
    formData.append('model', JSON.stringify(request));
    for (let i = 0; i < request.attachments.length; i++) {
      const name = `additional file -${i + 1}`;
      formData.append(name, request.attachments[i].file);
      request.attachments[i].name = name;
    }

    this.dynamicFormUtilityServices.appendDocuments(formData, prefix, request);
    return formData;
  }

  getVendorInformation(vendorNumber: string): Observable<Vendor> {
    return this.httpClient
      .get<Vendor>(
        `${environment.apiUrl}${this.urlPath}/get-vendor-information/${vendorNumber}`,
      )
      .pipe();
  }

  private Request(request: any, prefix: string) {
    const formData: FormData = new FormData();
    formData.append('model', JSON.stringify(request));
    return formData;
  }
}
